export const getBadgeVariant = (eventName: string) => {
  const lowerEvent = eventName.toLowerCase();
  if (lowerEvent.includes("delete")) return "error";
  if (lowerEvent.includes("create")) return "success";
  if (lowerEvent.includes("login") || lowerEvent.includes("logout")) return "neutral";
  return "info";
};

export const formatJsonValue = (value: any): string => {
  if (!value) return "No additional data";
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};